import React, { useEffect, useState } from 'react';
import DynamicForm, { withExtension } from 'components/Shared/DynamicForm';
import { FormProvider } from 'context/FormContext';
import { useAuthContext } from 'hooks/useAuthContext';
import { addDeliveryLog } from 'utils/SamplesUtil';
import RecieveSampleSchema from 'schemas/RecieveSample.schema.json';
import { useFormContext } from 'hooks/useFormContext';
import SkeletonForm from 'components/Shared/SkeletonForm';

const Form = ({ rowData, status, submit, onCancel }) => {
    // build form schema for Approve Dialog
    const { name } = useAuthContext();
    const defaults = {
        DeliveryDate: new Date().toISOString(),
        Username: name
    };
    
    const formContext = useFormContext();

    // updates schema in formContext, this will trigger the formcontext to build references (domains);
    useEffect(() => {
        let mounted = true;
        !formContext.schema && mounted && formContext.updateSchema(RecieveSampleSchema);
        return () => { mounted = false }
    }, [formContext]);

    // submit function for approve dialog form; will eventually perform the crud operation;
    const handleSubmit = async (data, exitForm) => {
        const payload = rowData.map((row, index) => ({
            BaseSampleId: row.BaseSampleId,
            DeliveryDate: data.DeliveryDate,
            Comments: data.Comments,
        }));
        const result = await addDeliveryLog(payload);
        if (result.success) {
            await exitForm();
        };
        return result;
    };

    return formContext.ready ? withExtension(DynamicForm, {
        schema: formContext.schema,
        disabledProperties: ["Username"],
        hiddenProperties: ["BaseSampleId"],
        cancel: true,
        defaultValues: defaults,
        onSubmit: async (e) => {
            return await handleSubmit(e, submit);
        },
        onCancel,
        inputVariant: "standard",
        title: true
    }) : <div style={{ width: 450 }}><SkeletonForm /></div>;
}

const RecieveSampleForm = ({ ...props }) => <FormProvider><Form {...props} /></FormProvider>;

export default RecieveSampleForm;